import { useMutation } from "@tanstack/react-query";
import { updateProfessionalDataService } from "../services/updateProfessionalData";

export const useUpdateProfessionalDataMutation = () =>
  useMutation({
    mutationFn: updateProfessionalDataService,
  });
